export function useLoader() {
  function setLoading(flag: boolean) {
    const blocker = document
      .getElementsByClassName('jps-loading-blocker')
      .item(0)
    if (blocker) {
      if (flag) {
        blocker.classList.add('jps-is-loading')
        window.setTimeout(() => setLoading(false), 20 * 1000)
      } else blocker.classList.remove('jps-is-loading')
    }
  }

  function isLoading(): boolean {
    const jpsElement = document
      .getElementsByClassName('jps-loading-blocker')
      .item(0)
    if (jpsElement) {
      jpsElement.classList.contains('jps-is-loading')
    }
    return false
  }

  function loadingExecute<T>(promise: Promise<T>): Promise<T> {
    setLoading(true)
    return promise
      .then(r => {
        setLoading(false)
        return r
      })
      .catch(r => {
        setLoading(false)
        return Promise.reject(r)
      })
  }

  const { snackbarSuccess } = useSnackbar()
  function loadingExecuteAndNotify<T>(
    successMsg: string,
    promise: Promise<T>,
  ): Promise<T> {
    setLoading(true)
    return promise
      .then(r => {
        snackbarSuccess({ ja: successMsg })
        setLoading(false)
        return r
      })
      .catch(r => {
        setLoading(false)
        return Promise.reject(r)
      })
  }

  return {
    setLoading,
    isLoading,
    loadingExecute,
    loadingExecuteAndNotify,
  }
}
